import type { UIStrings } from './en';

export const es: UIStrings = {
  'site.title': 'DopeJs — herramientas de código abierto para el desarrollo con agentes',
  'site.description':
    'DopeJs crea herramientas de código abierto para el desarrollo nativo con IA: entornos de ejecución de agentes, agentes de programación en terminal, utilidades de entorno para CLI y motores de renderizado Canvas.',

  'nav.projects': 'Proyectos',
  'nav.about': 'Acerca de',
  'nav.github': 'GitHub',
  'nav.skip': 'Ir al contenido',
  'nav.theme': 'Tema',
  'nav.language': 'Idioma',

  'hero.eyebrow': 'código abierto · desarrollado a la vista de todos',
  'hero.title': 'Herramientas para el desarrollo nativo con IA.',
  'hero.body':
    'DopeJs es un pequeño grupo de proyectos de código abierto en torno a una pregunta: ¿cómo es el software que usas a diario cuando los agentes forman parte del ciclo? Entornos de ejecución de agentes, agentes de programación en terminal, utilidades de entorno para CLI y motores de renderizado Canvas, todo desarrollado en público.',
  'hero.cta.projects': 'Ver proyectos',
  'hero.cta.github': 'Ver en GitHub',
  'hero.count': 'proyectos',

  'projects.title': 'Proyectos',
  'projects.repo': 'Repositorio',
  'projects.homepage': 'Sitio web',
  'projects.install': 'Instalar',
  'projects.copy': 'Copiar',
  'projects.copied': 'Copiado',
  'projects.details': 'Detalles',

  'status.stable': 'Publicado',
  'status.active': 'En desarrollo activo',
  'status.early': 'Temprano: no apto para producción',
  'status.design': 'Fase de diseño',

  'project.back': 'Todos los proyectos',
  'project.overview': 'Resumen',
  'project.highlights': 'Qué hace',
  'project.getStarted': 'Primeros pasos',
  'project.requirements': 'Requisitos',
  'project.facts': 'De un vistazo',
  'project.facts.status': 'Estado',
  'project.facts.languages': 'Lenguajes',
  'project.facts.license': 'Licencia',
  'project.facts.noLicense': 'Ninguna todavía',
  'project.links': 'Enlaces',
  'project.issues': 'Issues',
  'project.releases': 'Releases',
  'project.prev': 'Anterior',
  'project.next': 'Siguiente',

  'about.title': 'Acerca de DopeJs',
  'about.body':
    'Todo se desarrolla de forma abierta en GitHub. Las issues y los pull requests son bienvenidos en cualquier repositorio, igual que los informes honestos de que algo aún no funciona. Varios de estos proyectos están en fase previa al lanzamiento por diseño; cuando es así, el propio proyecto lo indica.',
  'about.cta': 'Sigue la organización en GitHub',

  'footer.built': 'Hecho con React y Vite. Código fuente en GitHub.',
  'footer.rights': 'DopeJs',
  'footer.translations': 'Las traducciones se han generado automáticamente; se agradecen las correcciones.',
};
